import { useState, type MouseEvent } from "react";
import { api } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";
import { triggerUrlDownload } from "../../../shared";

export function useDocumentDownload(
  orgCategory: SourceOrgCategory,
  orgId: string,
  docId: string,
  filename?: string
) {
  const [isLoading, setIsLoading] = useState(false);

  const handleDocumentClick = async (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      const url = await api.getDocumentDownloadUrl(orgCategory, orgId, docId);
      triggerUrlDownload(url, filename);
    } catch (error) {
      console.error("Failed to open document:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleDocumentClick,
  };
}
